export default __webpack_public_path__ + "static/media/glasses.bf762789.png";